export default {
  CREATE_PICK(state, payload) {
    const userId = payload.userId;
    const pick = state.allPicksList.filter((pick) => {
      return userId === pick.userId;
    });

    if (pick.length === 0) {
      // no pick found for this user Id, valid to add

      const newPick = {
        userId: payload.userId,
        nickName: payload.nickName,
        picksComplete: payload.picksComplete,
        paid: payload.paid,
        picksList: [],
      }

      for (let i = 0; i < payload.picksList.length; i++) {
        const pick = {
          gameId: payload.picksList[i].gameId,
          winner: payload.picksList[i].winner,
        };
  
        newPick.picksList.push(pick);
      }

      state.allPicksList.push(newPick);
    } else {
      // picks already exist for this user, use those
      console.log("existing userId = " + payload.userId);
      this.SET_PICKS(state, payload.userId);
    }
  },
  SET_PICKS(state, userId) {
    console.group("SET_PICKS");
    console.table(state.allPicksList);

    const pick = state.allPicksList.filter((pick) => {
      return userId === pick.userId;
    });

    if (pick.length === 1) {
      // state.currentUser = pick[0];
      Object.assign(state.currentPicks, pick[0]);
    }
    
    console.groupEnd();
  },
  CLEAR_PICKS(state) {
    state.currentPicks.userId = null;
    state.currentPicks.nickName = null;
    state.currentPicks.picksComplete = false;
    state.currentPicks.paid = false;
    state.currentPicks.picksList = null;
  },
  UPDATE_PICK(state, pick) {
    console.group("UPDATE_PICK");
    let newPick = true;

    for (let i = 0; i < state.allPicksList.length; i++ )     {
      if ( state.allPicksList[i].userId === pick.userId ) {
        Object.assign(state.allPicksList[i], pick);
        // do I need to "assign" all the picks in pick.picksList?
        console.info("Assigned pick to allPicksList[ " + i + " ]" );
        newPick = false;
        break;
      }
    }

    if ( newPick ) {
      // we didn't find it in the list, add it
      state.allPicksList.push(pick);
    }

    console.groupEnd();
  },
  CLEAR_ALL_PICKS(state) {
    state.allPicksList.length = 0;
  },
  LOAD_PICK(state, pick) {
    const newPick = new Object;
    Object.assign(newPick, pick);
    // do I need to "assign" all the picks in pick.picksList?

    state.allPicksList.push(newPick);
  },
  SET_GAMEPICKS(state, gamePicks) {
    const pick = state.currentPicks;

    pick.picksList = [];
    for (let i = 0; i < gamePicks.length; i++) {
      const gamePick = new Object;
      Object.assign(gamePick, gamePicks[i]);
      pick.picksList.push(gamePick);
    }
  },
}